import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
import { Symbols } from '@/symbols';
let SessionManagementApi = class SessionManagementApi {
    constructor(urls, http) {
        this.urls = urls;
        this.http = http;
        /**
         * 获取用户会话信息列表
         * @returns
         */
        this.getAccountsSessions = (params) => {
            const urls = this.urls.getAccountsSessions;
            return this.http.get({
                url: urls,
                params,
            });
        };
        /**
        * 获取公司会话信息列表
        * @returns
        */
        this.getCompanySessions = (params, id) => {
            const url = format(this.urls.getCompanySessions, { id });
            return this.http.get({
                url,
                params,
            });
        };
        /**
         * 删除会话id
         * @returns
         */
        this.deleteKickEmailSessions = (params) => {
            return this.http.delete({
                url: this.urls.deleteKickEmailSessions,
                params,
            });
        };
    }
};
SessionManagementApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.SessionManagementUrls)),
    __param(1, inject(Symbols.BoHttp)),
    __metadata("design:paramtypes", [Object, Object])
], SessionManagementApi);
export { SessionManagementApi };
